export default __webpack_public_path__ + "static/media/1.9f89bb93.png";